import { Icon, type IconName, Tooltip } from '@dev-spendesk/grapes';
import classNames from 'classnames';

import styles from './CardContentNew.module.css';

type Props = {
  title?: string;
  titleIcon?: IconName;
  numbers?: string;
  amount?: string;
  smallAmount?: string;
  className?: string;
  expiryDate?: string;
  amountTooltip?: string;
  theme?: 'light' | 'dark';
};

export const CardContentNew = ({
  title,
  titleIcon,
  numbers,
  amount,
  smallAmount,
  className,
  expiryDate,
  amountTooltip,
  theme = 'dark',
}: Props) => {
  return (
    <span
      className={classNames(className, theme == 'light' ? styles.white : null)}
    >
      <div className={styles.header}>
        <Icon size="xl" name="spendesk" />
        {title && (
          <div
            className={classNames(
              'max-w-[144px] overflow-hidden text-ellipsis whitespace-nowrap',
              styles.title,
            )}
          >
            {titleIcon && <Icon name={titleIcon} size="m" />}
            {title}
          </div>
        )}
      </div>
      {amountTooltip && amount ? (
        <Tooltip content={amountTooltip} triggerAsChild>
          <div className={styles.amount}>
            {smallAmount && (
              <div className={styles.smallAmount}>{smallAmount}</div>
            )}
            {amount}
          </div>
        </Tooltip>
      ) : (
        amount && (
          <div className={styles.amount}>
            {smallAmount && (
              <div className={styles.smallAmount}>{smallAmount}</div>
            )}
            {amount}
          </div>
        )
      )}
      {numbers && (
        <div
          className={classNames(
            styles.numbers,
            theme === 'light' ? styles.numbersLight : null,
          )}
          data-mask
        >
          {numbers?.replaceAll('.', '•')}
          {expiryDate && (
            <div className={styles.expiryDate} data-mask>
              {expiryDate}
            </div>
          )}
        </div>
      )}
    </span>
  );
};
